import { __read } from "tslib";
import { getClientRect, getScrollableAncestors, } from '@dnd-kit/core';
export function getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        var innerWidth_1 = window.innerWidth, innerHeight_1 = window.innerHeight;
        return {
            top: 0,
            left: 0,
            right: innerWidth_1,
            bottom: innerHeight_1,
            width: innerWidth_1,
            height: innerHeight_1,
        };
    }
    var _a = element.getBoundingClientRect(), top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight,
    };
}
export function getScrollPosition(scrollingContainer) {
    var minScroll = {
        x: 0,
        y: 0,
    };
    var maxScroll = {
        x: scrollingContainer.scrollWidth - scrollingContainer.clientWidth,
        y: scrollingContainer.scrollHeight - scrollingContainer.clientHeight,
    };
    var isTop = scrollingContainer.scrollTop <= minScroll.y;
    var isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    var isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    var isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll,
    };
}
export function getFirstScrollableAncestor(node) {
    var _a = __read(getScrollableAncestors(node, 1), 1), firstScrollableAncestor = _a[0];
    return firstScrollableAncestor !== null && firstScrollableAncestor !== void 0 ? firstScrollableAncestor : null;
}
export function scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) { measure = getClientRect; }
    if (!element) {
        return;
    }
    var _a = measure(element), top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    var firstScrollableAncestor = getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) {
        return;
    }
    if (bottom <= 0 ||
        right <= 0 ||
        top >= window.innerHeight ||
        left >= window.innerWidth) {
        element.scrollIntoView({
            block: 'center',
            inline: 'center',
        });
    }
}
//# sourceMappingURL=scrollUtil.js.map